import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TrophyIcon } from "@heroicons/react/24/outline";
export const WaveWinnersEmpty: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TrophyIcon className="tw-size-10 tw-text-iron-600" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-justify-center tw-py-16 tw-px-4"><div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-max-w-xs tw-text-center">{t0}<div className="tw-space-y-1.5"><p className="tw-text-base tw-font-medium tw-text-iron-300">No Winners to Display</p><p className="tw-text-sm tw-text-iron-500">This wave ended without any submissions</p></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};